.base {
	--trace-icon: 16px;
	--trace-row: 30px;

	margin-bottom: 12px;
	padding: 6px 14px 8px;
	border: 1px solid var(--parrot-chat-border);
	border-radius: var(--parrot-chat-radius-lg);
	background: var(--parrot-chat-surface);
	font-size: var(--parrot-chat-font-size-sm);
	line-height: 1.4;
}

.header {
	display: flex;
	align-items: center;
	gap: 8px;
	height: var(--trace-row);
	padding: 0;
	border: none;
	background: none;
	color: var(--parrot-chat-text-muted);
	font: inherit;
	cursor: pointer;
}

.header svg {
	width: var(--trace-icon);
	height: var(--trace-icon);
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
	transition: transform 0.15s ease;
}

.closed svg {
	transform: rotate(-90deg);
}

.header:hover {
	color: var(--parrot-chat-text-secondary);
}

.steps {
	margin: 0;
	padding: 0;
	list-style: none;
}

.step {
	position: relative;
	display: flex;
	align-items: center;
	gap: 8px;
	min-height: var(--trace-row);
}

/* Timeline connector, from below this step's icon to above the next one's. */
.step:not(:last-child)::after {
	content: "";
	position: absolute;
	left: calc(var(--trace-icon) / 2 - 0.5px);
	top: calc(50% + var(--trace-icon) / 2 + 2px);
	height: calc(var(--trace-row) - var(--trace-icon) - 4px);
	width: 1px;
	background: var(--parrot-chat-border-strong);
}

.icon {
	display: flex;
	flex-shrink: 0;
	width: var(--trace-icon);
	height: var(--trace-icon);
}

.icon svg {
	width: 100%;
	height: 100%;
	stroke-linecap: round;
	stroke-linejoin: round;
}

/* Filled discs with the mark knocked out in the card's own colour. */
.success,
.error {
	color: var(--parrot-chat-success);
}
.error {
	color: var(--parrot-chat-error);
}
.success circle,
.error circle {
	fill: currentColor;
	stroke: none;
}
.success path,
.error path {
	fill: none;
	stroke: var(--parrot-chat-surface);
	stroke-width: 2.5;
}

.cancelled {
	color: var(--parrot-chat-text-muted);
}
.cancelled circle {
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
}

.running {
	color: var(--parrot-chat-text-muted);
}
.spinner {
	animation: traceSpin 0.8s linear infinite;
}
.spinner circle {
	fill: none;
	stroke: currentColor;
	stroke-width: 2.5;
	stroke-dasharray: 42;
	stroke-dashoffset: 30;
}

.label {
	color: var(--parrot-chat-text);
}

.duration {
	color: var(--parrot-chat-text-muted);
	font-size: 12px;
	font-variant-numeric: tabular-nums;
}

@keyframes traceSpin {
	to {
		transform: rotate(360deg);
	}
}
